import { BEST_IN_SLOT_API } from '@/utils/constants'
import { timeoutFetcher } from '@/utils/fetcher'
import useSWR from 'swr'

export default function useBestinslotBrc20Valid(inscriptionId?: string) {
	const { data, isLoading, error } = useSWR(
		inscriptionId ? `${BEST_IN_SLOT_API}/get_brc20_info/${inscriptionId}` : null,
		timeoutFetcher,
		{
			revalidateOnMount: true,
			revalidateOnFocus: true
		}
	)

	const bestinslotTransferInfo = data?.[0]?.transfer_info
	return {
		valid: !!!bestinslotTransferInfo?.used && bestinslotTransferInfo?.error === 0,
		isLoading: isLoading,
		error: error
	}
}
